import { render, staticRenderFns } from "./StatCardComponent.vue?vue&type=template&id=79de0ae2&"
import script from "./StatCardComponent.vue?vue&type=script&lang=js&"
export * from "./StatCardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports